export const MEDLBID = "3a486ef9-c99d-11ee-a772-00155d6a9292";
export const MEDRANK = "e0053d78-f8d3-11ee-aeab-00155d0769b9";
